// import React from 'react';
// import { Row, Col } from 'antd';
// import { PlusOutlined } from '@ant-design/icons';
// import StatCard from './StatCard';

// function Dashboard() {
//   // Reusable card wrapper style
//   const containerStyle = {
//     padding: '16px',
//     background: '#f9fafc',
//     borderRadius: '12px',
//     boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
//     transition: 'all 0.3s ease-in-out',
//     marginBottom: '24px',
//   };

//   return (
//     <div style={containerStyle}>
//       <Row gutter={[24, 24]}>
//         <Col xs={24} sm={12} md={6}>
//           <StatCard
//             icon={<PlusOutlined style={{ fontSize: 24, color: '#722ed1' }} />}
//             title="Total Medications"
//             value="387"
//             trend="+5"
//             color="#722ed1"
//           />
//         </Col>
//         <Col xs={24} sm={12} md={6}>
//           <StatCard
//             icon={<PlusOutlined style={{ fontSize: 24, color: '#fa8c16' }} />}
//             title="Low Stock Items"
//             value="12"
//             trend="-3"
//             trendDown={false}
//             color="#fa8c16"
//           />
//         </Col>
//         <Col xs={24} sm={12} md={6}>
//           <StatCard
//             icon={<PlusOutlined style={{ fontSize: 24, color: '#52c41a' }} />}
//             title="Prescriptions"
//             value="43"
//             subtitle="Today"
//             trend="+8"
//             color="#52c41a"
//           />
//         </Col>
//         <Col xs={24} sm={12} md={6}>
//           <StatCard
//             icon={<PlusOutlined style={{ fontSize: 24, color: '#1890ff' }} />}
//             title="Pending Orders"
//             value="5"
//             subtitle="Arriving soon"
//             color="#1890ff"
//           />
//         </Col>
//       </Row>
//     </div>
//   );
// }

// export default Dashboard;



import React from 'react';
import { Row, Col } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import StatCard from './StatCard';

function Dashboard() {
  const containerStyle = {
    padding: '16px',
    background: '#f9fafc',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
    marginBottom: '24px',
  };

  return (
    <div style={containerStyle}>
      <Row gutter={[24, 24]} style={{ alignItems: 'stretch' }}>
        <Col xs={24} sm={12} md={6} style={{
          minHeight: '200px',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}>
          <StatCard
            icon={<PlusOutlined style={{ fontSize: 24, color: '#722ed1' }} />}
            title="Total Medications"
            value="387"
            trend="+5"
            color="#722ed1"
          />
        </Col>
        <Col xs={24} sm={12} md={6} style={{ height: '100%' }}>
          <StatCard
            icon={<PlusOutlined style={{ fontSize: 24, color: '#fa8c16' }} />}
            title="Low Stock Items"
            value="12"
            trend="-3"
            trendDown={false}
            color="#fa8c16"
          />
        </Col>
        <Col xs={24} sm={12} md={6} style={{ height: '100%' }}>
          <StatCard
            icon={<PlusOutlined style={{ fontSize: 24, color: '#52c41a' }} />}
            title="Prescriptions"
            value="43"
            subtitle="Today"
            trend="+8"
            color="#52c41a"
          />
        </Col>
        <Col xs={24} sm={12} md={6} style={{ height: '100%' }}>
          <StatCard
            icon={<PlusOutlined style={{ fontSize: 24, color: '#1890ff' }} />}
            title="Pending Orders"
            value="5"
            subtitle="Arriving soon"
            color="#1890ff"
          />
        </Col>
      </Row>
    </div>
  );
}

export default Dashboard;


